import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { fetchStoreSites, type StoreSitesItemData } from "@app/api/options/store";

export interface StoreSiteSelectOption {
    label: string;
    value: string;
}

/** 客户端站点下拉（会话内缓存，登录后拉取一次） */
export const useStoreSitesStore = defineStore("storeSites", () => {
    const items = ref<StoreSitesItemData[]>([]);
    const loaded = ref(false);
    const loading = ref(false);

    const selectOptions = computed<StoreSiteSelectOption[]>(() =>
        items.value.map(item => ({
            label: item.countryCode,
            value: item.countryCode,
        })),
    );

    async function fetchOptions(force = false) {
        if (loading.value) return;
        if (loaded.value && !force) return;

        loading.value = true;
        try {
            const data = await fetchStoreSites();
            items.value = data.items ?? [];
            loaded.value = true;
        } catch (e) {
            console.error("[storeSites]", e);
            if (force) items.value = [];
        } finally {
            loading.value = false;
        }
    }

    function fetchIfNeeded() {
        return fetchOptions(false);
    }

    function refresh() {
        return fetchOptions(true);
    }

    function reset() {
        items.value = [];
        loaded.value = false;
        loading.value = false;
    }

    return { items, loaded, loading, selectOptions, fetchIfNeeded, refresh, reset };
});
